module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/add-registration-child/add-registration-child.component.css
// module id = ./src/app/shared/components/add-registration-child/add-registration-child.component.css
// module chunks = main